export const ADMIN_CONTENT_PAGES = [
  {
    key: "global",
    label: "Global",
    icon: "Building2",
    sections: ["company"],
  },
  {
    key: "home",
    label: "Home",
    icon: "Sparkles",
    sections: ["hero", "intro", "ticker", "trust_strip", "stats", "home_copy"],
  },
  {
    key: "services",
    label: "Services",
    icon: "Briefcase",
    sections: ["services_page", "services", "process"],
  },
  {
    key: "products",
    label: "Products",
    icon: "Package",
    sections: ["products_page", "products", "products_specs"],
  },
  {
    key: "about",
    label: "About",
    icon: "Users",
    sections: ["about_page", "about_mission_vision", "values", "markets", "about_stats"],
  },
  {
    key: "quality",
    label: "Quality",
    icon: "Award",
    sections: ["quality_page", "quality_blocks"],
  },
  {
    key: "compliance",
    label: "Compliance",
    icon: "Scale",
    sections: ["compliance_page", "compliance_blocks"],
  },
  {
    key: "contact",
    label: "Contact",
    icon: "Mail",
    sections: ["contact_page", "faqs"],
  },
];
